webpackJsonp([269829036549620],{

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(11);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(45);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(121);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _theme = __webpack_require__(15);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServicesBlock = function ServicesBlock(_ref) {
		var data = _ref.data;
	
	
		var serviceInfo = data.map(function (data) {
			return _react2.default.createElement(
				_gatsbyLink2.default,
				{ key: data.node.id, to: data.node.frontmatter.path, className: 'service' },
				_react2.default.createElement(
					'div',
					{
						className: _style2.default.dynamic([['2833339685', [_theme2.default.colors.white, _theme2.default.colors.red, _theme2.default.breakpoints.lg]]]) + ' ' + 'service-image'
					},
					_react2.default.createElement(_gatsbyImage2.default, {
						alt: data.node.frontmatter.title,
						sizes: data.node.frontmatter.featuredImage.childImageSharp.sizes
					})
				),
				_react2.default.createElement(
					'div',
					{
						className: _style2.default.dynamic([['2833339685', [_theme2.default.colors.white, _theme2.default.colors.red, _theme2.default.breakpoints.lg]]]) + ' ' + 'service-excerpt'
					},
					_react2.default.createElement(
						'h4',
						{
							className: _style2.default.dynamic([['2833339685', [_theme2.default.colors.white, _theme2.default.colors.red, _theme2.default.breakpoints.lg]]])
						},
						data.node.frontmatter.title
					),
					_react2.default.createElement(
						'div',
						{
							className: _style2.default.dynamic([['2833339685', [_theme2.default.colors.white, _theme2.default.colors.red, _theme2.default.breakpoints.lg]]]) + ' ' + 'service-excerpt-content'
						},
						data.node.excerpt + "Read More"
					)
				),
				_react2.default.createElement(_style2.default, {
					styleId: '2833339685',
					css: ['.service-image.__jsx-style-dynamic-selector{position:relative;}', '.service-excerpt.__jsx-style-dynamic-selector{position:absolute;background-color:rgba(0,0,0,0.3);-webkit-transition:top 0.2s ease-in-out;transition:top 0.2s ease-in-out;top:calc(100% - 32px);left:0;right:0;bottom:0;z-index:2;}', '.service-excerpt-content.__jsx-style-dynamic-selector{position:relative;top:50%;width:80%;display:block;font-size:14px;padding:1em;color:' + _theme2.default.colors.white + ';}', 'h4.__jsx-style-dynamic-selector{color:white;padding:.5em;margin:0;background-color:' + _theme2.default.colors.red + ';bottom:0;}', '@media(min-width:' + _theme2.default.breakpoints.lg + 'px){.service:hover .service-excerpt.__jsx-style-dynamic-selector{top:0;}}'],
					dynamic: [_theme2.default.colors.white, _theme2.default.colors.red, _theme2.default.breakpoints.lg]
				})
			);
		});
	
		return _react2.default.createElement(
			'div',
			{
				className: _style2.default.dynamic([['2946859764', [_theme2.default.breakpoints.md]]]) + ' ' + 'services-block'
			},
			serviceInfo,
			_react2.default.createElement(_style2.default, {
				styleId: '2946859764',
				css: ['.services-block.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-flow:row wrap;-ms-flex-flow:row wrap;flex-flow:row wrap;}', '.services-block.__jsx-style-dynamic-selector .service{display:block;position:relative;overflow:hidden;width:100%;margin-bottom:2em;}', '@media(min-width:' + _theme2.default.breakpoints.md + 'px){.services-block.__jsx-style-dynamic-selector{-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;}.services-block.__jsx-style-dynamic-selector .service{width:calc(50% - 1em);}}'],
				dynamic: [_theme2.default.breakpoints.md]
			})
		);
	};
	
	exports.default = ServicesBlock;
	module.exports = exports['default'];

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _style = __webpack_require__(11);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(50);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Page = __webpack_require__(54);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Accreditations = __webpack_require__(37);
	
	var _Accreditations2 = _interopRequireDefault(_Accreditations);
	
	var _Container = __webpack_require__(19);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Services = __webpack_require__(92);
	
	var _Services2 = _interopRequireDefault(_Services);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pageTitle = "Services";
	var pageDesc = 'Castle Electrical Services Ltd are able to carry out all your Electrical contracting needs, be it in a commercial or domestic setting';
	
	var ServicePage = function ServicePage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'main',
	    { id: 'services', className: 'jsx-' + _Page2.default.__scopedHash
	    },
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: pageTitle + ' | Castle Electrical Services Ltd',
	      meta: [{ name: 'description', content: pageDesc }, { property: 'og:title', content: '' + pageTitle }, { property: 'og:type', content: 'article' }, { property: 'og:description', content: pageDesc }, { property: 'og:url', content: ("https://johnwilson65.github.io") + '/services' }, { property: 'og:site_name', content: 'Castle Electrical Services Ltd' }, { property: 'og:image', content: ("https://johnwilson65.github.io") + '/logos/logo-1024.png' }],
	      htmlAttributes: { 'lang': 'en' }
	    }),
	    _react2.default.createElement(_Accreditations2.default, { data: data }),
	    _react2.default.createElement(
	      _Container2.default,
	      null,
	      _react2.default.createElement(
	        'h1',
	        {
	          className: 'jsx-' + _Page2.default.__scopedHash + ' ' + 'title'
	        },
	        'Our Services'
	      ),
	      _react2.default.createElement(
	        'p',
	        {
	          className: 'jsx-' + _Page2.default.__scopedHash
	        },
	        'Castle Electrical Services Ltd are able to carry out all Electrical work be it in a Commercial or Domestic setting.'
	      ),
	      _react2.default.createElement(_Services2.default, { data: data.allMarkdownRemark.edges })
	    ),
	    _react2.default.createElement(_style2.default, {
	      styleId: _Page2.default.__scopedHash,
	      css: _Page2.default.__scoped
	    })
	  );
	};
	
	exports.default = ServicePage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-services-js-b093fe7bcf016eb2dc5d.js